<template>
  <!-- Same selection action bar as Generate Invoices' tables (.gi-action-bar
       in PendingInvoicesTable / ApprovedDispatchedInvoicesTable): count on
       the left, primary buttons on the right, ✕ Clear last. Shown only
       while something is selected (LIQ-2071 AC21/25). Actions a role can't
       use are never passed in; actions that don't apply to every selected
       row come in disabled, with the reason as a tooltip. -->
  <div v-if="count > 0" class="iat-bar">
    <span class="iat-count">
      <b-spinner v-if="selectingAll" small class="mr-1" />
      <template v-if="allSelected && count > 1">All {{ formatCount(count) }} {{ noun }} selected</template>
      <template v-else>{{ formatCount(count) }} selected</template>
    </span>

    <div class="iat-buttons">
      <span
        v-for="action in actions"
        :key="action.key"
        v-b-tooltip.hover
        :title="action.disabled ? action.disabledReason : ''"
      >
        <b-button
          size="sm"
          :variant="action.variant || 'primary'"
          :disabled="action.disabled || busy || selectingAll"
          @click="$emit('action', action.key)"
        >
          <b-spinner v-if="busyAction === action.key" small class="mr-1" />
          {{ action.label }}
        </b-button>
      </span>
      <b-button size="sm" variant="warning" :disabled="busy" @click="$emit('clear')">✕ Clear</b-button>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'InvoiceActionsToolbar',
  props: {
    count: { type: Number, default: 0 },
    allSelected: { type: Boolean, default: false },
    selectingAll: { type: Boolean, default: false },
    // Plural noun for the "All N … selected" cue, e.g. 'invoices' / 'keys'.
    noun: { type: String, default: 'rows' },
    // [{ key, label, variant?, disabled?, disabledReason? }]
    actions: { type: Array, default: () => [] },
    // key of the action currently running, if any
    busyAction: { type: String, default: null },
  },
  emits: ['action', 'clear'],
  setup(props) {
    const busy = computed(() => !!props.busyAction)
    const formatCount = (n) => new Intl.NumberFormat('en-US').format(n)
    return { busy, formatCount }
  },
})
</script>

<style scoped>
/* Mirrors .gi-action-bar exactly. */
.iat-bar {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 12px; flex-wrap: wrap; gap: 8px;
}
.iat-count { font-size: 13px; font-weight: 600; color: #32325d; }
.iat-buttons { display: flex; gap: 6px; flex-wrap: wrap; }
</style>
